const NPSheetTab = Object.freeze({
  OVERVIEW: 'OVERVIEW',
  STREAM: 'STREAM',
  MEDIA: 'MEDIA'
})
export default NPSheetTab
// RESERVE BELOW
